require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-seahawk-tackle-russell-okung-greater-foundation.json") })
        }
      }, "path---blog-seahawk-tackle-russell-okung-greater-foundation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-seahawk-tackle-russell-okung-greater-foundation!./.cache/json/blog-seahawk-tackle-russell-okung-greater-foundation.json
// module id = 1018
// module chunks = 231608221292675